import type { RouteDef } from '../router';
import { t, getLocale } from '../i18n';
import type { TranslationKey } from '../i18n/types';
import { aboutPageHtml } from '@roamzy/shared';

/**
 * /about — editorial / E-E-A-T page.
 *
 * Why this exists: Google's Quality Rater Guidelines weigh E-E-A-T heavily
 * for sites making commercial recommendations. This page is the trust
 * signal: clear method, named operator workflow, audit trail link, contact.
 *
 * Localised via the i18n bundle in every locale we ship. Body content
 * carries factual claims (Jaccard %, prices.json reference, etc.) verbatim
 * across locales — the marketing tone adapts but the numbers don't.
 *
 * Indexable. Linked from footer.
 */
const aboutRoute: RouteDef = {
  path: '/about',
  routeType: 'article',
  metaTitle: 'About Roamzy — Editorial methodology & contact',
  metaDesc:
    'Who writes Roamzy\'s eSIM catalog, how the per-MB rates are calculated, and how to flag a correction. One operator + AI-assisted research, transparent sources.',
  // The server sends this page (backend about-legal-body.ts, the same
  // renderer); the router keeps it on first paint.
  prerenderMarker: '.about-route',
  hydrate: () => '',
  render() {
    return aboutPageHtml({ locale: getLocale(), t: (key, vars) => t(key as TranslationKey, vars) });
  },
};

export default aboutRoute;
